import React, { useEffect } from 'react';

const Spotlight = () => {
    useEffect(() => {
        const handleMouseMove = (event) => {
            const x = event.clientX; // Get cursor X coordinate
            const y = event.clientY; // Get cursor Y coordinate

            // Update the background style of the spotlight div
            document.getElementById('spotlight').style.background = 
                `radial-gradient(600px at ${x}px ${y}px, rgba(29, 78, 216, 0.15), transparent 80%)`;
        };

        window.addEventListener('mousemove', handleMouseMove);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);

    return <div id="spotlight"></div>; // Render the spotlight div
};

export default Spotlight;